import PropTypes from 'prop-types';
import React from 'react';
import Router from '../Router';

class RouterProvider extends React.Component {
  getChildContext() {
    return {
      router: Router,
    };
  }
  render() {
    return React.Children.only(this.props.children);
  }
}

RouterProvider.childContextTypes = {
  router: PropTypes.object,
};

export default RouterProvider;
